import React, { createContext, useContext } from 'react'
import { TrackerRuntimeValue } from './types'

const TrackerRuntimeContext = createContext<TrackerRuntimeValue>({})

interface TrackerRuntimeProviderProps extends TrackerRuntimeValue {
  children: React.ReactNode
}

export const TrackerRuntimeProvider = ({
  apiBaseUrl,
  atlasKey,
  children,
  data,
  mapTilesBaseUrl,
  orderId,
}: TrackerRuntimeProviderProps) => {
  return (
    <TrackerRuntimeContext.Provider
      value={{
        apiBaseUrl,
        atlasKey,
        data,
        mapTilesBaseUrl,
        orderId,
      }}
    >
      {children}
    </TrackerRuntimeContext.Provider>
  )
}

export function useTrackerRuntime(): TrackerRuntimeValue {
  return useContext(TrackerRuntimeContext)
}
